module.exports = __webpack_public_path__ + "static/media/icon-powerpoint.a77c0db1.jpg";